var _rect, _rect2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3746",
    "data-name": "Group 3746",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 32.294,
    viewBox: "0 0 120 32.294",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1736",
    "data-name": "Rectangle 1736",
    width: 120,
    height: 32.294,
    rx: 5,
    fill: "#fcbc00",
    opacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1737",
    "data-name": "Rectangle 1737",
    width: 116.771,
    height: 29.065,
    rx: 5,
    transform: "translate(1.615 1.615)",
    fill: "#fcbc00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3831",
    "data-name": "Path 3831",
    d: "M3.826,0H107.89C3.822.014.045,2.625,0,16.147V2.6C0,1.166,1.713,0,3.826,0Z",
    transform: "translate(3.229 3.229)",
    fill: "#fff",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3832",
    "data-name": "Path 3832",
    d: "M104.064,17.688H0C104.067,17.674,107.89,15.116,107.89,8v7.084C107.89,17.653,106.177,17.688,104.064,17.688Z",
    transform: "translate(8.881 11.376)",
    fill: "#fff",
    opacity: 0.15
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarNumber);
export default __webpack_public_path__ + "static/media/car-number.594da13df644f0b09176d98fd6c68d84.svg";
export { ForwardRef as ReactComponent };